import { Progress } from "antd";
import { formatDate } from "../../../utility/commonConstant";

export const singleContentColumns = [
  {
    title: "Username",
    dataIndex: "userName",
    key: "userName",
  },
  {
    title: "Full Name",
    dataIndex: "fullName",
    key: "fullName",
  },
  {
    title: "Progress (%)",
    dataIndex: "progress",
    key: "progress",
     render: (value) => {
    const val = value ?? 0;

    let strokeColor = "#FFB200"; 
    let trailColor = "#FFF8C7";  

    if (val >= 33 && val < 66) {
      strokeColor = "#1777FF"; 
      trailColor = "#E8F1FF"; 
    }

    if (val >= 66) {
      strokeColor = "#088A15"; 
      trailColor = "#EEFFF0"; 
    }

    return (
      <Progress
        percent={val}
        size="small"
        strokeColor={strokeColor}
        trailColor={trailColor}
        format={(percent) => `${percent.toFixed(2)}%`}
      />
    );
  },
  },
  {
    title: "Acknowledged",
    dataIndex: "acknowledged",
    key: "acknowledged",
    render: (value) => (value ? "Yes" : "No"),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Last Visited",
    dataIndex: "lastVisited",
    key: "lastVisited",
    render: (value) =>
      value ? formatDate(value) : "-",
  },
]